module.exports = __webpack_public_path__ + "4226788ac66823efcae1c689c7c2b85d.ttf";